<template>
  <q-header
    v-model="model"
    class="h-80 !absolute inset-0 bg-200 py-20 ml-[var(--Nv0-sidebar-width)]"
  >
    <div
      class="w-full flex items-center flex-nowrap gap-12 container-base"
    >
      <p class="text-neutral-70 text-paragraph-1">
        {{ t('welcomeBack') }}
        <span class="!font-semibold capitalize">
          {{ nome }}
        </span>
      </p>
      <div class="flex-1" />

      <template v-for="botao in botoesHeader" :key="botao.id">
        <OButton
          secondary
          size="sm"
          target="_blank"
          :href="botao.link"
          :label="botao.titulo"
          :icon="botao.icone || undefined"
          :icon-size="botao.icone ? '24px' : undefined"
          class="!h-[2.25rem] text-paragraph-3 !font-normal !text-sm shadow-sm !py-4 !px-10"
        />
      </template>

      <template
        v-if="context?.user?.superuser || context?.user?.staff"
      >
        <OButton
          secondary
          size="sm"
          href="/admin"
          target="_blank"
          class="!size-[2.25rem] !min-h-0 !p-0 shadow-sm"
        >
          <IconConfig class="!size-24" />
          <q-tooltip
            v-bind="tooltipProps"
            anchor="top middle"
            self="bottom middle"
          >
            {{ t('settings') }}
          </q-tooltip>
        </OButton>

        <OButton
          secondary
          size="sm"
          :to="{ name: 'home_admin' }"
          class="!size-[2.25rem] !min-h-0 !p-0 shadow-sm"
        >
          <IconOrbit class="!size-28 !text-primary-admin" />
          <q-tooltip
            v-bind="tooltipProps"
            anchor="top middle"
            self="bottom middle"
          >
            {{ t('homeAdmin') }}
          </q-tooltip>
        </OButton>
      </template>

      <OButton
        class="!h-[2.25rem] !min-h-0 !p-4 shadow-sm"
        secondary
        size="sm"
      >
        <!-- <OAvatar size="34px" /> -->
        <q-avatar
          color="primary-pure/10"
          text-color="primary-pure"
          size="24px"
          rounded
        >
          <p class="text-headline-3 !text-xs">
            {{ iniciais }}
          </p>
        </q-avatar>
        <q-icon name="keyboard_arrow_down" />
        <HeaderMenuUser :user="context?.user" :assessment />
      </OButton>
    </div>
  </q-header>
</template>

<script setup>
import { computed, inject, ref } from 'vue'
import { tooltipProps } from 'js/utils/GLOBAL'
import { useI18n } from 'vue-i18n'
import HeaderMenuUser from './HeaderMenuUser.vue'
import IconConfig from 'public/icons/config.svg'
import IconOrbit from 'public/icons/orbit.svg'
import OButton from 'components/Button/OButton.vue'
import useAssessment from 'composables/useAssessment'

const { t } = useI18n()

const { botoesHeader, assessment } = useAssessment()

const model = ref(true)
const context = inject('context')

const nome = computed(
  () =>
    context?.user?.nome ||
    context?.user?.first_name ||
    context?.user?.username
)

const iniciais = computed(() => {
  if (context?.user?.first_name && context?.user?.last_name) {
    return (
      context?.user?.first_name.charAt(0).toUpperCase() +
      context?.user?.last_name.charAt(0).toUpperCase()
    )
  }
  if (context?.user?.first_name) {
    return context?.user?.first_name.slice(0, 2).toUpperCase()
  }
  return context?.user?.username.slice(0, 2).toUpperCase()
})
</script>

<style lang="scss" scoped></style>
